import { index } from "~/api/contractBalanceOperationHistory";
import * as types from "../mutation-types";
import store from "../../store";

function normalizeResponsePayload(payload = null) {
  if (!payload || typeof payload !== "object") {
    return {
      list: [],
      meta: null
    };
  }

  const nestedData = payload?.data;
  if (Array.isArray(nestedData)) {
    return {
      list: nestedData,
      meta: payload?.meta || null
    };
  }

  if (nestedData && typeof nestedData === "object") {
    if (Array.isArray(nestedData.data)) {
      return {
        list: nestedData.data,
        meta: nestedData.meta || payload?.meta || null
      };
    }
  }

  return {
    list: [],
    meta: payload?.meta || null
  };
}

export const state = {
  list: [],
  meta: null,
  isLoading: false
};

export const mutations = {
  [types.SET_CONTRACT_BALANCE_OPERATION_HISTORY_LIST](state, list) {
    state.list = Array.isArray(list) ? list : [];
  },
  [types.SET_CONTRACT_BALANCE_OPERATION_HISTORY_META](state, meta) {
    state.meta = meta || null;
  },
  [types.SET_IS_LOADING_CONTRACT_BALANCE_OPERATION_HISTORY](state, status) {
    state.isLoading = Boolean(status);
  }
};

export const actions = {
  async fetchContractBalanceOperationHistory({ commit }, { contractId = null, params = null } = {}) {
    commit(types.SET_IS_LOADING_CONTRACT_BALANCE_OPERATION_HISTORY, true);

    const activeContractId = contractId || store.getters["contract/activeContract"]?.id;
    if (!activeContractId) {
      commit(types.SET_CONTRACT_BALANCE_OPERATION_HISTORY_LIST, []);
      commit(types.SET_CONTRACT_BALANCE_OPERATION_HISTORY_META, null);
      commit(types.SET_IS_LOADING_CONTRACT_BALANCE_OPERATION_HISTORY, false);
      return Promise.resolve();
    }

    try {
      const response = await index(activeContractId, params);
      const normalizedPayload = normalizeResponsePayload(response?.data);

      commit(types.SET_CONTRACT_BALANCE_OPERATION_HISTORY_LIST, normalizedPayload.list);
      commit(types.SET_CONTRACT_BALANCE_OPERATION_HISTORY_META, normalizedPayload.meta);

      return response;
    } finally {
      commit(types.SET_IS_LOADING_CONTRACT_BALANCE_OPERATION_HISTORY, false);
    }
  }
};

export const getters = {
  list: (state) => state.list,
  meta: (state) => state.meta,
  isLoading: (state) => state.isLoading
};
